const STORAGE_KEY = 'ticketLotteryEntries';

export const loadTicketLotteryEntries = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn('Failed to load ticket lottery entries:', error);
    return [];
  }
};

const saveEntries = (entries) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch (error) {
    console.warn('Failed to save ticket lottery entries:', error);
  }
};

export const saveTicketLotteryEntry = ({ eventId, eventName, email }) => {
  const entries = loadTicketLotteryEntries();
  const normalizedEmail = String(email || '').trim().toLowerCase();
  const exists = entries.some(
    (entry) => entry.eventId === eventId && entry.email === normalizedEmail
  );
  if (exists) {
    return { ok: false, message: 'You are already entered for this event.' };
  }
  const next = [
    ...entries,
    {
      eventId,
      eventName,
      email: normalizedEmail,
      createdAt: new Date().toISOString(),
    },
  ];
  saveEntries(next);
  return { ok: true };
};

export const hasTicketLotteryEntry = (eventId) => {
  if (!eventId) return false;
  const entries = loadTicketLotteryEntries();
  return entries.some((entry) => entry.eventId === eventId);
};

export const removeTicketLotteryEntry = (eventId) => {
  if (!eventId) return;
  const entries = loadTicketLotteryEntries();
  const next = entries.filter((entry) => entry.eventId !== eventId);
  saveEntries(next);
};
